import React from 'react'
import { Controller, useFieldArray, useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Checkbox, Form, Grid, Input } from 'semantic-ui-react'
import { CO2El } from '../../../style'
import { FormFields } from '~/components/FormFields'
import { splitEvery } from '~/utils/helpers'
import InfoPopup from '~/components/InfoPopup'
interface Props {
  options: any[]
}

const ManureFields: React.FC<Props> = ({ options }) => {
  const { t } = useTranslation()
  const { control, getValues } = useFormContext()

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'manureStorageTypes',
    keyName: 'key'
  })

  function handleChecked(field, checked) {
    if (checked) {
      append({
        ...field,
        percent: ''
      })
      return
    }
    const index = fields.findIndex(fieldManure => fieldManure['id'] === field.id)
    if (index >= 0) {
      remove(index)
    }
  }

  function checkPercentage() {
    const manureTypes = getValues('manureStorageTypes')
    return manureTypes.reduce((previousValue, currentValue) => {
      return previousValue + parseFloat(currentValue.percent.replace(',', '.'))
    }, 0) != 100
  }

  const optionsSplit = splitEvery(options, 4)

  return <Form.Field>
    <label style={{ fontSize: '15px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
        <div>{t('Type of manure storage')}</div>
        <InfoPopup
          content={t('Please select all types of manure storage. Then distribute the percentage share among the selected options. In total these must add up to 100%.')}
          styleIcon={{ fontSize: '1.2em' }}
          position={'top center'}
        />
      </div>
    </label>
    <CO2El.StyledDivider />
    <Grid columns={2} style={{ marginTop: '1em' }}>
      <Controller
        name={'manureStorageTypes'}
        control={control}
        rules={{
          validate: () => !checkPercentage()
        }}
        render={({ fieldState }) => {
          const error = fieldState.error ? checkPercentage() : false
          return <>
            {optionsSplit.map((optionSplit, index) => {
              return <Grid.Column key={`manureColumn-${index}`}>
                <Grid columns={2}>
                  {optionSplit.map((option, index) => {
                    const fieldIndex = fields.findIndex(field => field['id'] === option.id)
                    return <Grid.Row style={{ alignItems: 'center', padding: '0.6rem 0rem' }}
                      key={option.id}
                    >
                      <Grid.Column>
                        <Checkbox
                          label={option.label}
                          checked={Boolean(fields.find(manureField => manureField['id'] === option.id))}
                          onChange={(e, data) => handleChecked(option, data.checked)}
                        />
                      </Grid.Column>
                      <Grid.Column>
                        {fieldIndex >= 0 ? <FormFields.Input
                          control={control}
                          allowDecimals
                          decimalScale={2}
                          style={{ width: 200 }}
                          error={error}
                          typeInput={'controled'}
                          suffix={' %'}
                          noErrorMessage
                          withoutAsterisk
                          rules={{
                            required: true
                          }}
                          name={`manureStorageTypes[${fieldIndex}].percent`}
                          placeholder={t('in %')}
                        /> : <Input
                          style={{ width: 200 }}
                          disabled
                          placeholder={t('in %')}
                        />
                        }
                      </Grid.Column>
                    </Grid.Row>
                  })}
                </Grid>
              </Grid.Column>
            })}

          </>
        }}
      />
    </Grid>
  </Form.Field>
}
export default ManureFields